import React, { memo } from 'react';

import { Box, Heading } from 'grommet';

import MarkdownContent from '../MarkdownContent';
import { WallcoveringsCollectionProducts } from './WallcoveringsCollectionProducts';

interface WallcoveringsCollectionProps {
  path: string;
  children: number;
  collection: { products: any[]; title: string; descriptionHtml: string };
}

const WallcoveringsCollection = ({
  children,
  collection,
}: WallcoveringsCollectionProps) => {
  return (
    <Box>
      {(collection.title || collection.descriptionHtml) && (
        <Box
          pad={{ horizontal: 'xlarge', vertical: 'medium', top: 'large' }}
          style={{ zIndex: 1 }}
          margin={{ top: 'xlarge' }}
          direction="row-responsive"
          border={{ side: 'bottom', size: 'small' }}
          gap={'medium'}
        >
          <Box>
            {collection.title && (
              <Heading style={{ maxWidth: '11em', marginTop: 0 }} level={1}>
                {collection.title}
              </Heading>
            )}
          </Box>
          <Box>
            {collection.descriptionHtml && (
              <MarkdownContent>{collection.descriptionHtml}</MarkdownContent>
            )}
          </Box>
        </Box>
      )}
      <WallcoveringsCollectionProducts collection={collection} />
    </Box>
  );
};

export default memo(WallcoveringsCollection);
